var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBowler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 167,
    height: 153,
    viewBox: "0 0 167 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9849",
    "data-name": "Group 9849",
    transform: "translate(-784 -477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6052",
    "data-name": "Rectangle 6052",
    transform: "translate(784 477)",
    fill: "#fff",
    stroke: "#d4d4d4",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 167,
    height: 153,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 165,
    height: 151,
    rx: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9845",
    "data-name": "Group 9845"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1571",
    "data-name": "Ellipse 1571",
    cx: 9.934,
    cy: 9.934,
    r: 9.934,
    transform: "translate(866.3 505.315)",
    fill: "#ff9800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79985",
    "data-name": "Path 79985",
    d: "M43.82,31.444,25.541,23.3c-1.987-.993-2.98,1.987-3.974,3.974s-8.146,14.305-7.55,16.491a3.988,3.988,0,0,0,3.775,2.782,2.52,2.52,0,0,0,1.192-.2L43.423,38.8A3.817,3.817,0,0,0,46.2,35.219,4.213,4.213,0,0,0,43.82,31.444Z",
    transform: "translate(834.4 520.165)",
    fill: "#00796b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79986",
    "data-name": "Path 79986",
    d: "M44.362,16.417,39.991,14.43a5.314,5.314,0,0,0-6.954,2.583L9.394,67.876a4.062,4.062,0,0,0,1.987,5.364,5.8,5.8,0,0,0,1.788.4,3.753,3.753,0,0,0,3.576-2.186s19.074-26.425,20.663-29.6,9.735-18.478,9.735-18.478A5.4,5.4,0,0,0,44.362,16.417Z",
    transform: "translate(829.487 511.151)",
    fill: "#009688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79987",
    "data-name": "Path 79987",
    d: "M58.18,16.418a4.055,4.055,0,0,0-5.563-.6l-9.934,8.345L29.967,17.213A4.718,4.718,0,0,0,23.411,19c-1.589,2.583-.795,5.762,1.589,6.755l16.491,6.755a5.8,5.8,0,0,0,1.788.4,4.185,4.185,0,0,0,2.583-.993l11.921-9.934A4.016,4.016,0,0,0,58.18,16.418Z",
    transform: "translate(842.889 512.143)",
    fill: "#ff9800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79988",
    "data-name": "Path 79988",
    d: "M15.29,32.08l6.755-10.133,9.139,1.192,2.98-6.159A5.034,5.034,0,0,1,38.337,14H20.058a3.9,3.9,0,0,0-3.378,1.788L8.733,27.709a3.943,3.943,0,0,0,1.192,5.563,2.966,2.966,0,0,0,1.987.6A4.155,4.155,0,0,0,15.29,32.08Z",
    transform: "translate(828.559 511.184)",
    fill: "#ff9800"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowler);
export default __webpack_public_path__ + "static/media/bowler.5b3fb52170b5976baa04021acd45748f.svg";
export { ForwardRef as ReactComponent };